/* RESPONSIBLE TEAM: team-tickets-1 */
import { EmbeddedRecordsMixin } from '@ember-data/serializer/rest';
import EmbercomBaseSerializer from 'embercom/serializers/base/embercom-base-serializer';

export default EmbercomBaseSerializer.extend(EmbeddedRecordsMixin, {
  attrs: {
    channels: {
      serialize: false,
      deserialize: 'records',
    },
    notificationTypes: {
      serialize: false,
      deserialize: 'records',
    },
    notificationRules: {
      serialize: false,
      deserialize: 'records',
    },
  },
});
